import { Link } from 'react-router-dom';
import CompanyAddress from '../components/CompanyAddress';
import PolicyLayout, {
  PolicyContact,
  PolicyList,
  PolicySection,
} from '../components/PolicyLayout';
import {
  COMPANY_NAME,
  PHONE,
  SITE_DOMAIN,
  SITE_NAME,
  SITE_TAGLINE,
  SITE_URL,
} from '../constants/site';

const UPDATED = 'May 25, 2026';

export default function AboutPage() {
  return (
    <PolicyLayout title="About Us" lastUpdated={UPDATED}>
      <PolicySection title="Who we are">
        <p>
          {SITE_NAME} ({SITE_URL}) is a travel booking platform helping customers find affordable flights, hotels, rental
          cars, vacation packages, and cruises worldwide. Our mission is simple: {SITE_TAGLINE.toLowerCase()} with
          transparent pricing and responsive support.
        </p>
        <p>
          {SITE_DOMAIN} is operated by {COMPANY_NAME}, a U.S.-registered company. We partner with global distribution
          systems, airlines, and lodging providers to bring you real-time search results and secure checkout.
        </p>
      </PolicySection>

      <PolicySection title="What we offer">
        <PolicyList
          items={[
            'Flight search across major airlines and routes',
            'Hotel stays from budget to premium properties',
            'Car rentals at airports and city locations',
            'Vacation packages combining flights and hotels',
            'Cruise itineraries with multiple cabin categories',
            '24/7 phone and email support for bookings and changes',
          ]}
        />
      </PolicySection>

      <PolicySection title="How we work">
        <p>
          {SITE_NAME} acts as an intermediary between you and travel suppliers. When you book, your contract for travel
          services is with the applicable airline, hotel, or other provider, subject to their fare rules and policies. We
          facilitate search, payment, confirmation delivery, and customer service on your behalf.
        </p>
      </PolicySection>

      <PolicySection title="Our values">
        <PolicyList
          items={[
            'Transparency — clear disclosure of fees and fare rules before you pay',
            'Service — live agents available around the clock',
            'Security — industry-standard payment processing and data protection',
            'Choice — compare multiple suppliers in one search experience',
          ]}
        />
      </PolicySection>

      <PolicySection title="Registered office">
        <p>
          <strong>{COMPANY_NAME}</strong>
          <br />
          <CompanyAddress as="span" />
          <br />
          Phone: <a href={`tel:${PHONE.replace(/[^\d+]/g, '')}`}>{PHONE}</a>
        </p>
      </PolicySection>

      <PolicySection title="Policies and legal">
        <p>
          Review our <Link to="/flight/terms">Terms &amp; Conditions</Link>, <Link to="/flight/privacy">Privacy Policy</Link>,{' '}
          <Link to="/flight/cookies">Cookie Policy</Link>, <Link to="/flight/fare-disclosure">Fare Disclosure Policy</Link>, and{' '}
          <Link to="/flight/service-fees">Service Fees</Link> for complete information about using {SITE_DOMAIN}.
        </p>
      </PolicySection>

      <PolicySection title="Contact us">
        <p>
          Ready to plan your trip? <Link to="/flight">Start a search</Link> or <Link to="/flight/support">contact our team</Link>.
        </p>
        <PolicyContact />
      </PolicySection>
    </PolicyLayout>
  );
}
